/**
 * QA Comment Service
 *
 * API client for QA comment CRUD operations.
 * Endpoints: /qa/reviews/{content_id}/comments
 */

import { apiClient } from './apiClient';
import type {
  QAComment,
  QACommentCreate,
  QACommentUpdate,
  QACommentListResponse,
} from '../types/qaReview';

export const qaCommentService = {
  async list(contentId: string, tenantId: string): Promise<QACommentListResponse> {
    const response = await apiClient.get<QACommentListResponse>(
      `/qa/reviews/${contentId}/comments?tenant_id=${tenantId}`
    );
    return response.data;
  },

  async create(contentId: string, tenantId: string, data: QACommentCreate): Promise<QAComment> {
    const response = await apiClient.post<QAComment>(
      `/qa/reviews/${contentId}/comments?tenant_id=${tenantId}`,
      data
    );
    return response.data;
  },

  async update(commentId: string, tenantId: string, data: QACommentUpdate): Promise<QAComment> {
    const response = await apiClient.put<QAComment>(
      `/qa/reviews/comments/${commentId}?tenant_id=${tenantId}`,
      data
    );
    return response.data;
  },

  async delete(commentId: string, tenantId: string): Promise<void> {
    await apiClient.delete(`/qa/reviews/comments/${commentId}?tenant_id=${tenantId}`);
  },
};
